import * as Views from "./views";


const Module = {
    name: "bis",
    defaultRoutePath: "/bis/configuration",
    menuItemScope: "bis",
    menuItemName: "configuration",

    routes: [
        {
            path: "/bis/configuration",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
    ]
}



export default Module;
